import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IndexComponent } from './index/index.component';
import { LocationComponent } from './location/location.component';
import { BlogComponent } from './blog/blog.component';
import { BlogEntryComponent } from './blog-entry/blog-entry.component';
import { SharedModule } from '../shared/shared.module';
import { HomeRoutingModule } from './home-routing.module';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { ConditionsComponent } from './conditions/conditions.component';


@NgModule({
  declarations: [IndexComponent, LocationComponent, BlogComponent, BlogEntryComponent, PrivacyPolicyComponent, ConditionsComponent],
  imports: [
    CommonModule,
    SharedModule,
    HomeRoutingModule
  ]
})
export class HomeModule { }
